// Packages and components
import styled from 'styled-components';
import { Tab } from 'grommet';

import { TypographySettings } from '@theme/globals/typography';

import { colors } from '@theme/globals/colors';

export const StyledTab: typeof Tab = styled(Tab)`
  div {
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-color: transparent;
    margin: 0 8px;
    padding-bottom: 12px;
    & > span {
      color: #272727;
      font-family: ${TypographySettings['subhead-bold'].family};
      font-size: ${TypographySettings['subhead-bold'].size};
      font-weight: ${TypographySettings['subhead-bold'].weight};
      line-height: ${TypographySettings['subhead-bold'].height};
    }
  }

  /** Active tab */
  &[aria-selected='true'] > div {
    border-color: ${colors ? (colors.primary as string) : '#000'};
    & > span {
      color: ${colors ? (colors.primary as string) : '#000'};
    }
  }

  /** First tab */
  div:first-of-type {
    margin-left: 16px;
  }
`;

// aria-selected
